export default __webpack_public_path__ + "static/media/code.c24ae482.svg";